'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp2;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _SimilarTrip = require('./SimilarTrip.scss');

var _SimilarTrip2 = _interopRequireDefault(_SimilarTrip);

var _DefaultTrip = require('../Trip/DefaultTrip.scss');

var _DefaultTrip2 = _interopRequireDefault(_DefaultTrip);

var _reactRedux = require('react-redux');

var _Link = require('components/Link/Link');

var _Link2 = _interopRequireDefault(_Link);

var _reactIntl = require('react-intl');

var _helpers = require('utils/helpers');

var _price = require('utils/price');

var _media = require('utils/media');

var _session = require('redux/modules/session');

var sessionActions = _interopRequireWildcard(_session);

var _trip = require('redux/modules/trip');

var _popup = require('redux/modules/popup');

var _RatingPoint = require('../General/RatingPoint/RatingPoint');

var _RatingPoint2 = _interopRequireDefault(_RatingPoint);

var _WishlistButton = require('../General/Buttons/WishlistButton');

var _WishlistButton2 = _interopRequireDefault(_WishlistButton);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  SimilarTrip: {
    displayName: 'SimilarTrip'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/TripDetail/SimilarTrip.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var SimilarTrip = _wrapComponent('SimilarTrip')((_dec = (0, _reactRedux.connect)(function (state) {
  return {
    sessionData: state.session.data,
    isLoggedIn: state.session.isLoggedIn,
    rates: state.info.exchangeRates,
    isWishlisted: state.wishlist.wishlistObj.isWishlisted,
    // omitBookingFee: state.info.userConfig.omitBookingFee,
    siteConfigs: state.info.siteConfigs,
    //
    locale: state.language.locale,
    weChatEveryLink: state.info.siteConfigs.weChatEveryLink
  };
}, (0, _extends3.default)({}, sessionActions, {
  clickSimilarTrip: _trip.clickSimilarTrip,
  impressSimilarTrip: _trip.impressSimilarTrip,
  openWeChatPopup: _popup.openWeChatPopup
})), _dec2 = (0, _reactCssModules2.default)(_SimilarTrip2.default), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(SimilarTrip, _Component);

  function SimilarTrip() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SimilarTrip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SimilarTrip.__proto__ || (0, _getPrototypeOf2.default)(SimilarTrip)).call.apply(_ref, [this].concat(args))), _this), _this.getQuantity = function () {
      var _this$props = _this.props,
          trip = _this$props.trip,
          sessionData = _this$props.sessionData;

      if (trip.is_per_day !== true) {
        return sessionData.quantity > trip.max_travelers ? trip.max_travelers : sessionData.quantity;
      }
      return sessionData.quantity > trip.max_day ? trip.max_day : sessionData.quantity;
    }, _this.click = function () {
      _this.props.clickSimilarTrip(_this.props.trip._id, _this.props.prob > 0 ? 'jaccard' : 'no jaccard', _this.props.index);
      _this.impress();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SimilarTrip, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.interval = setInterval(function () {
        var rect = _this2.refs.root.getBoundingClientRect();
        var elemCenter = (rect.top + rect.bottom * 2) / 3;
        if (elemCenter <= window.innerHeight && rect.bottom >= 60) {
          _this2.impress();
        }
      }, 1000);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.interval) {
        clearInterval(this.interval);
      }
    }
  }, {
    key: 'impress',
    value: function impress() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
        this.props.impressSimilarTrip(this.props.trip._id, this.props.prob > 0 ? 'jaccard' : 'no jaccard', this.props.index);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          trip = _props.trip,
          sessionData = _props.sessionData,
          rates = _props.rates,
          isWishlisted = _props.isWishlisted,
          siteConfigs = _props.siteConfigs;
      var locale = this.props.locale;
      // const {currency, quantity} = sessionData;

      var currency = sessionData.currency;

      var pinImage = require('theme/images/icons/location-pin.png');
      var defaultImage = require('theme/images/default-img.png');
      var wishlisted = isWishlisted[trip._id] || { state: false, loading: false };

      var quantity = this.getQuantity();
      var isUsedForeignPrices = trip.foreign_full_prices !== undefined && trip.foreign_full_prices[currency] !== undefined;
      var prices = isUsedForeignPrices ? trip.foreign_full_prices[currency] : trip.full_prices;
      var displayPrice = (0, _helpers.getDisplayPrice)(quantity, prices, true);
      displayPrice = isUsedForeignPrices ? displayPrice : (0, _price.convertUnit)(trip.lx_currency || 'THB', 'THB', displayPrice, rates);
      var displaySeasonedPrice = (0, _helpers.getDisplaySeasonedPrice)(quantity, prices, true);
      return _react3.default.createElement(
        _Link2.default,
        { to: '/trip/' + trip.slug, styleName: 'link', locale: locale, onClick: this.click },
        _react3.default.createElement(
          'div',
          { ref: 'root', styleName: 'container' },
          _react3.default.createElement(
            'div',
            { styleName: 'image' },
            _react3.default.createElement('img', { src: trip.cover_image && (0, _media.path)(trip.cover_image, 'featureCover'), styleName: 'image-img', alt: trip.name }),
            trip.tags.some(function (s) {
              return s.match(/_staff_pick$/);
            }) && _react3.default.createElement(
              'div',
              { className: _DefaultTrip2.default['tag-container'], style: { zIndex: 1, position: 'absolute', top: '15px', left: '0' } },
              _react3.default.createElement(
                'div',
                { className: _DefaultTrip2.default['feature-tag-band'] },
                _react3.default.createElement('i', { className: _DefaultTrip2.default['tmt-tag-icon'] }),
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.trip_detail.feature' })
              ),
              _react3.default.createElement(
                'div',
                null,
                _react3.default.createElement('div', { className: _DefaultTrip2.default['feature-tag-arrow-top'] }),
                _react3.default.createElement('div', { className: _DefaultTrip2.default['feature-tag-arrow-bottom'] })
              )
            ),
            _react3.default.createElement(
              'div',
              { styleName: 'image-shadow' },
              _react3.default.createElement(
                'div',
                { styleName: 'location-container' },
                _react3.default.createElement(
                  'div',
                  { styleName: 'location' },
                  _react3.default.createElement('img', { src: pinImage, width: '10', height: '15', alt: 'pin' }),
                  _react3.default.createElement(
                    'span',
                    null,
                    trip.destination_location
                  )
                ),
                trip.rating > 0 && _react3.default.createElement(
                  'div',
                  { styleName: 'rating-flex' },
                  _react3.default.createElement(_RatingPoint2.default, { point: trip.rating }),
                  _react3.default.createElement(
                    'span',
                    null,
                    '(',
                    trip.review_count,
                    ')'
                  )
                )
              ),
              _react3.default.createElement(
                'div',
                { styleName: 'trip-price-mobile' },
                _react3.default.createElement(
                  'div',
                  { styleName: 'price-mobile-container' },
                  _react3.default.createElement(
                    'span',
                    { styleName: 'person-mobile' },
                    trip.is_per_day === true ? _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.item.per_day' }) : _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.item.per_person' })
                  ),
                  _react3.default.createElement(
                    'span',
                    { styleName: 'price-mobile' },
                    (0, _helpers.commaizeInt)((0, _price.ceil)(displayPrice, currency, rates, !isUsedForeignPrices)),
                    ' ',
                    siteConfigs.fixYuan && currency === 'CNY' ? '元' : currency
                  ),
                  trip.discount_percentage > 0 ? _react3.default.createElement(
                    'span',
                    { styleName: 'cross-price-mobile' },
                    (0, _helpers.commaizeInt)((0, _price.ceil)(displaySeasonedPrice, currency, rates, !isUsedForeignPrices)),
                    ' ',
                    siteConfigs.fixYuan && currency === 'CNY' ? '元' : currency
                  ) : null
                ),
                trip.discount_percentage ? _react3.default.createElement(
                  'div',
                  { styleName: 'price-off-mobile' },
                  _react3.default.createElement(
                    'p',
                    null,
                    _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.item.discount', values: { percent: trip.discount_percentage * 100 + '%', lineBreak: _react3.default.createElement('br', null) } })
                  )
                ) : null
              )
            ),
            _react3.default.createElement(
              'div',
              { styleName: 'wishlist-container' },
              _react3.default.createElement(_WishlistButton2.default, { active: wishlisted.state !== wishlisted.loading, tripSlug: trip.slug, tripId: trip._id })
            )
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'title-wishlist-container' },
            _react3.default.createElement(
              'div',
              { styleName: 'title-container' },
              _react3.default.createElement(
                'h3',
                { className: 'similar-trip-name', styleName: 'title' },
                trip.name
              ),
              _react3.default.createElement(
                'div',
                { styleName: 'footer-flex' },
                _react3.default.createElement(
                  'div',
                  { styleName: 'pic-name-container' },
                  _react3.default.createElement(
                    'div',
                    { styleName: 'mini-pic' },
                    _react3.default.createElement('img', { src: trip.user_id && trip.user_id.avatar_image ? (0, _media.path)(trip.user_id.avatar_image, 'profileAvatar') : defaultImage, alt: trip.user_id && trip.user_id.name && trip.user_id.name.first + ' ' + trip.user_id.name.last })
                  ),
                  _react3.default.createElement(
                    'p',
                    null,
                    trip.user_id && trip.user_id.name && trip.user_id.name.first + ' ' + trip.user_id.name.last
                  )
                ),
                this.props.showStartAt && trip.starting_time && _react3.default.createElement(
                  'span',
                  { styleName: 'start-at' },
                  'Trip starts at ',
                  _react3.default.createElement(
                    'span',
                    { styleName: 'time' },
                    trip.starting_time
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return SimilarTrip;
}(_react2.Component), _class2.propTypes = {
  trip: _react2.PropTypes.object,
  sessionData: _react2.PropTypes.object,
  isLoggedIn: _react2.PropTypes.bool,
  rates: _react2.PropTypes.object,
  impressSimilarTrip: _react2.PropTypes.func,
  clickSimilarTrip: _react2.PropTypes.func,
  isWishlisted: _react2.PropTypes.object,
  prob: _react2.PropTypes.number,
  showStartAt: _react2.PropTypes.bool,
  // omitBookingFee: PropTypes.bool,
  index: _react2.PropTypes.number,
  siteConfigs: _react2.PropTypes.object,
  //
  locale: _react2.PropTypes.string,
  weChatEveryLink: _react2.PropTypes.bool,
  openWeChatPopup: _react2.PropTypes.func
}, _temp2)) || _class) || _class));

exports.default = SimilarTrip;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TripDetail/SimilarTrip.js
// module id = 321
// module chunks = 47